import React from 'react';

const TelegramIcon = () => {
	return (
		<svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M6 11.2553L7.78626 16.0513C7.78626 16.0513 8.00959 16.5 8.24872 16.5C8.48786 16.5 12.0447 12.9107 12.0447 12.9107L16 5.5L6.06374 10.0173L6 11.2553Z'
				fill='#C8DAEA'
			/>
			<path
				d='M8.33083 12.5L8.00569 16.0206C8.00569 16.0206 7.86959 17.0993 8.92817 16.0206C9.98675 14.9418 11 14.11 11 14.11'
				fill='#A9C6D8'
			/>
			<path
				d='M5.9338 11.6604L2.32038 10.4116C2.32038 10.4116 1.88853 10.2257 2.02759 9.80428C2.05621 9.71738 2.11396 9.64343 2.28669 9.51635C3.08733 8.92438 17.1058 3.57967 17.1058 3.57967C17.1058 3.57967 17.5017 3.43819 17.7351 3.5323C17.7928 3.55126 17.8448 3.58615 17.8857 3.63341C17.9265 3.68067 17.9548 3.73859 17.9677 3.80125C17.9929 3.91193 18.0034 4.0258 17.999 4.13958C17.9979 4.238 17.9867 4.32922 17.9782 4.47227C17.8928 5.93353 15.3377 16.8394 15.3377 16.8394C15.3377 16.8394 15.1849 17.4776 14.6372 17.4994C14.5026 17.5041 14.3685 17.4799 14.2429 17.4283C14.1173 17.3768 14.0028 17.299 13.9061 17.1995C12.8313 16.2188 9.11649 13.5706 8.29561 12.9882C8.2771 12.9748 8.2615 12.9574 8.24988 12.937C8.23826 12.9167 8.23088 12.894 8.22824 12.8704C8.21677 12.809 8.2797 12.733 8.2797 12.733C8.2797 12.733 14.7482 6.634 14.9203 5.99374C14.9337 5.94413 14.8833 5.91966 14.8157 5.94139C14.3861 6.10904 6.93839 11.098 6.11641 11.6486C6.05724 11.6676 5.9947 11.6716 5.9338 11.6604Z'
				fill='white'
			/>
		</svg>
	);
};

export default TelegramIcon;
